export class Erro {
  codigoErro: number;
  datAtualizacao: Date;
  idCompil: number;
  idDoc: number;
  idErroCompil: number;
  msg: string;
}

export function erro(msg: string): Erro {
  const e = new Erro();
  e.msg = msg;
  return e;
}
